<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          icon="el-icon-error"
          v-if="permission.departmentcompany_edit"
          @click="forbid(scope.row)"
          :hidden="hideForbidBtn(scope.row)"
          >停用
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-circle-check"
          v-if="permission.departmentcompany_edit"
          @click="start(scope.row)"
          :hidden="hideStartBtn(scope.row)"
          >启用
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  updateStart,
  updateOut,
} from '@/api/v4ward/department/departmentcompany';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 80,
        tip: false,
        border: true,
        indexLabel: '序号',
        index: true,
        viewBtn: true,
        selection: false,
        columnBtn: false,
        refreshBtn: false,

        delBtn: false,
        searchMenuSpan: 6,
        column: [
          {
            label: 'id',
            prop: 'id',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            hide: true,
          },
          {
            label: '公司名称',
            prop: 'companyName',
            search: true,
            maxlength: 30,
            showWordLimit: true,
            overHidden: true,
            rules: [
              {
                required: true,
                message: '请输入公司名称',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '简称',
            prop: 'forShort',
            maxlength: 30,
            showWordLimit: true,
            overHidden: true,
            search: true,
          },
          {
            label: '单位地址',
            prop: 'companyAddress',
            type: 'textarea',
            span: 24,
            row: 4,
            maxlength: 200,
            showWordLimit: true,
            overHidden: true,
          },
          {
            label: '排序号',
            prop: 'companyIndex',
            hide: true,
            maxlength: 8,
            showWordLimit: true,
            rules: [
              { pattern: /^[0-9]*[0-9][0-9]*$/, message: '请输入正整数' },
              {
                required: true,
                message: '请输入排序号',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '启用状态',
            prop: 'startStatus',
            type: 'select',
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=switch',
            disabled: true,
            props: { label: 'dictValue', value: 'dictKey' },
            search: true,
            addDisplay: false,
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.departmentcompany_add, false),
        viewBtn: this.vaildData(this.permission.departmentcompany_view, false),
        delBtn: this.vaildData(this.permission.departmentcompany_delete, false),
        editBtn: this.vaildData(this.permission.departmentcompany_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    hideStartBtn(row) {
      //    --》隐藏按钮
      return row.startStatus !== 0;
    },
    hideForbidBtn(row) {
      //    --》隐藏按钮
      return row.startStatus !== 1;
    },
    start(row) {
      this.$confirm('确定启用?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return updateStart(row);
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    forbid(row) {
      this.$confirm('确定停用?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return updateOut(row);
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>
